import { useDispatch } from "react-redux";
import { setIsErrorPage } from "../redux/slices/navigation";

export default function useGetDataError() {
  const dispatch = useDispatch();

  const checkErrorStatus = (status) => {
    dispatch(setIsErrorPage(status === 404 || status === 403));
  };

  return { checkErrorStatus };
}
